/** @jsx jsx */
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Flex, Heading, jsx, Text } from 'theme-ui'

const MakerCard = ({ maker }) => {
  const { article, mainImage, name, pronouns, shortDescription, wineryName } =
    maker

  return (
    <Flex pt={[5, 9, 7, 9]} sx={{ flexDirection: 'column', height: '100%' }}>
      <Box
        bg="white"
        px={[3, 5, 4, 5]}
        pb={[4, 6, 5, 6]}
        sx={{ borderRadius: '8px', flexGrow: '1' }}
      >
        <Box
          mt={['-40px', '-72px', '-56px', '-72px']}
          mb={[2, 4]}
          sx={{
            borderRadius: '50%',
            height: ['200px', '256px', '232px', '256px'],
            overflow: 'hidden',
            transform: 'translateZ(0)',
            width: ['200px', '256px', '232px', '256px'],
          }}
        >
          <GatsbyImage
            image={mainImage.gatsbyImageData}
            alt={mainImage.description}
          />
        </Box>
        <Box mx={[0, 3, 2, 3]}>
          <Heading as="h3" variant="title3" mb="4px">
            {name}
          </Heading>
          <Text as="p" variant="subtitle2" mb={[1, 2]}>
            {wineryName}
          </Text>
          <Text as="p" variant="body2">
            {shortDescription}
          </Text>
          {article && (
            <Box mt={2} sx={{ a: { variant: 'text.textLink' } }}>
              <Link
                to={`/blog/${article.slug}/`}
                aria-label={`Read ${name}'s story`}
              >{`Read ${pronouns?.split('/')?.[1] || 'their'} story`}</Link>
            </Box>
          )}
        </Box>
      </Box>
    </Flex>
  )
}

export default MakerCard
